import { render, staticRenderFns } from "./select-config.component.vue?vue&type=template&id=568efd2b&scoped=true"
import script from "./select-config.component.vue?vue&type=script&lang=js"
export * from "./select-config.component.vue?vue&type=script&lang=js"
import style0 from "./select-config.component.vue?vue&type=style&index=0&id=568efd2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568efd2b",
  null
  
)

export default component.exports